import { cn } from '@/utils/cn';

interface SplashScreenProps {
  className?: string;
}

export function SplashBrand({
  logoClassName,
  showWordmark = true,
}: {
  logoClassName?: string;
  showWordmark?: boolean;
} = {}) {
  return (
    <>
      <img
        src="/icons/logo.svg"
        alt="Gymbal"
        className={cn('w-24 h-24 mb-4 animate-pulse-scale', logoClassName)}
      />
      {showWordmark ? <h1 className="text-2xl font-semibold text-primary-accent">Gymbal</h1> : null}
    </>
  );
}

export function SplashScreen({ className }: SplashScreenProps) {
  return (
    <div
      className={cn(
        'min-h-screen bg-neutral-950 flex flex-col items-center justify-center',
        className
      )}
    >
      <SplashBrand />
    </div>
  );
}
